export const validateObjectTypeId = objectTypeId => {
  if (!objectTypeId) {
    throw new Error(`Expected objectTypeId to be defined but received ${objectTypeId}`);
  }
  return objectTypeId;
};